export default __webpack_public_path__ + "static/media/Read More - Megosu.f34e82f7.pdf";